// Device-specific gradients
export const xboxGradientLight =
  "linear-gradient(to-br, rgba(34, 197, 94, 0.08), transparent, transparent)";
export const xboxGradientDark =
  "linear-gradient(to-br, rgba(34, 197, 94, 0.05), transparent, transparent)";
export const windowsGradientLight =
  "linear-gradient(to-br, rgba(59, 130, 246, 0.08), transparent, transparent)";
export const windowsGradientDark =
  "linear-gradient(to-br, rgba(59, 130, 246, 0.05), transparent, transparent)";

// Channe-specific gradients
export const channelGradientLight =
  "linear-gradient(to-br, rgba(59, 130, 246, 0.08), transparent, transparent)";
export const channelGradientDark =
  "linear-gradient(to-br, rgba(59, 130, 246, 0.05), transparent, transparent)";
export const versionGradientLight =
  "linear-gradient(to-br, rgba(147, 51, 234, 0.08), transparent, transparent)";
export const versionGradientDark =
  "linear-gradient(to-br, rgba(147, 51, 234, 0.05), transparent, transparent)";

const gradients = {
  // Device-specific gradients
  xbox: xboxGradientLight,
  windows: windowsGradientLight,

  // Resource-specific gradients
  channel: channelGradientLight,
  version: versionGradientLight,

  // modes
  modes: {
    dark: {
      // Device-specific gradients
      xbox: xboxGradientDark,
      windows: windowsGradientDark,

      // Resource-specific gradients
      channel: channelGradientDark,
      version: versionGradientDark,
    },
  },
};

export default gradients;
